// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__12PBH","author":"Table_author__w57vB","authorImage":"Table_authorImage__3gb-s","unreadRow":"Table_unreadRow__2ieKX"};